import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              alt="Abu Ayaan Services Logo" 
              className="h-12 w-auto" 
              src="https://static.readdy.ai/image/f5502c8213cacad10181856e9050c60c/ed731c15cb79f79d6f6f2b2cd62b80e9.png"
            />
            <span className={`text-xl font-bold ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              Abu Ayaan Services WLL
            </span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              About Us
            </a>
            <a href="#services" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </a>
            <a href="#mission" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Mission & Vision
            </a>
            <a href="#contact" className={`text-sm font-medium hover:text-teal-500 transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </a>
            <a 
              href="tel:+97336096336" 
              className="bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>
          
          <button 
            className="md:hidden cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <a href="#about" className="block text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors">
              About Us
            </a>
            <a href="#services" className="block text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors">
              Services
            </a>
            <a href="#mission" className="block text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors">
              Mission & Vision
            </a>
            <a href="#contact" className="block text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors">
              Contact
            </a>
            <a 
              href="tel:+97336096336" 
              className="block bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors text-center cursor-pointer"
            >
              Call Now
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
